export function setMeta(meta) {
    return {
        type: 'SET_META',
        payload: meta,
    };
}
